import * as i0 from '@angular/core';
import { Component, Input, EventEmitter, ElementRef, Output, ViewChild, ViewEncapsulation, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from 'se-fe-header';
import { SeFeHeaderModule } from 'se-fe-header';

class SeFeAccordionHeaderComponent {
    set seFeDataTitle(title) {
        this.title = title;
    }
    set seFeDataSubtitle(subtitle) {
        this.subtitle = subtitle;
    }
}
SeFeAccordionHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeAccordionHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeAccordionHeaderComponent, selector: "se-fe-accordion-header", inputs: { title: "title", seFeDataTitle: "seFeDataTitle", subtitle: "subtitle", seFeDataSubtitle: "seFeDataSubtitle" }, ngImport: i0, template: "<se-fe-header\n  [seFeDataTitle]=\"title\"\n  [seFeDataSubtitle]=\"subtitle\"\n  seFeDataLevel=\"0\"\n  seFeDataSize=\"600\">\n  <svg seFeHeaderVisual xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-hidden=\"true\">\n    <path d=\"M24 24H0V0h24v24z\" fill=\"none\" opacity=\".87\"/>\n    <path d=\"M15.88 9.29L12 13.17 8.12 9.29c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z\"/>\n  </svg>\n</se-fe-header>\n", styles: [":host{display:flex;cursor:pointer;width:100%;border-radius:4px;padding:12px 8px;overflow:hidden}:host[aria-expanded=true] svg{transform:rotate(-180deg)}:host:hover{background-color:#f5fafd}:host:active{background-color:#f5fafd;outline:#d6edf5 2px auto}:host:focus-visible{outline:1px solid #fff;outline-offset:-.5px;box-shadow:0 0 0 calc(0px + 2px) #fff,0 0 0 calc(0px + 4px) #00668f,0 0 0 calc(0px + 6px) #fff}se-fe-header{width:100%}svg{width:1.78rem;height:1.78rem;transition:transform .1s ease-in-out;margin-top:-1px}\n"], components: [{ type: i1.SeFeHeaderComponent, selector: "se-fe-header", inputs: ["size", "_level", "seFeDataTitle", "titleText", "seFeDataSubtitle", "subtitleText", "seFeDataSize", "seFeDataLevel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-accordion-header',
                    templateUrl: './se-fe-accordion-header.component.html',
                    styleUrls: ['./se-fe-accordion-header.component.scss'],
                }]
        }], propDecorators: { title: [{
                type: Input
            }], seFeDataTitle: [{
                type: Input,
                args: ['seFeDataTitle']
            }], subtitle: [{
                type: Input
            }], seFeDataSubtitle: [{
                type: Input,
                args: ['seFeDataSubtitle']
            }] } });

const ACCORDION_ACTION_CLASS = 'se-fe-accordion__actions--padding';
class SeFeAccordionComponent {
    constructor() {
        this.toggled = false;
        this._level = '3';
        this.seFeExpandedChange = new EventEmitter();
        this.id = `se-fe-accordion-${SeFeAccordionComponent.timeStamp}-${SeFeAccordionComponent.counter++}`;
        this.contentId = `se-fe-accordion-content-${SeFeAccordionComponent.timeStamp}-${SeFeAccordionComponent.counter++}`;
    }
    set expanded(value) {
        this.toggled = value;
    }
    get expanded() {
        return this.toggled;
    }
    set seFeDataTitle(title) {
        this.title = title;
    }
    set seFeDataSubtitle(subtitle) {
        this.subtitle = subtitle;
    }
    set seFeDataHeadingLevel(level) {
        this._level = level;
    }
    get level() {
        return Number(this._level) > 0 ? this._level : null;
    }
    ngAfterViewInit() {
        this.applyActionClass();
    }
    onClick() {
        this.toggled = !this.toggled;
        this.seFeExpandedChange.emit(this.toggled);
    }
    get role() {
        return Number(this._level) > 0 ? 'heading' : null;
    }
    get ariaControls() {
        return this.expanded ? this.contentId : null;
    }
    onKeydown(e) {
        switch (e.keyCode) {
            case 13:
                this.toggled = !this.toggled;
                this.seFeExpandedChange.emit(this.toggled);
                break;
            case 32:
                e.sto;
                e.preventDefault();
                this.toggled = !this.toggled;
                this.seFeExpandedChange.emit(this.toggled);
                break;
        }
    }
    applyActionClass() {
        this.hasActions ? this.actionsContent.nativeElement.classList.add(ACCORDION_ACTION_CLASS) : '';
    }
    get hasActions() {
        var _a, _b;
        return !!((_b = (_a = this.actionsContent) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.innerHTML);
    }
}
SeFeAccordionComponent.timeStamp = Date.now();
SeFeAccordionComponent.counter = 1;
SeFeAccordionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeAccordionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeAccordionComponent, selector: "se-fe-accordion", inputs: { expanded: ["seFeDataExpanded", "expanded"], title: "title", seFeDataTitle: "seFeDataTitle", subtitle: "subtitle", seFeDataSubtitle: "seFeDataSubtitle", seFeDataHeadingLevel: "seFeDataHeadingLevel" }, outputs: { seFeExpandedChange: "seFeExpandedChange" }, viewQueries: [{ propertyName: "actionsContent", first: true, predicate: ["actionsContent"], descendants: true, read: ElementRef }], ngImport: i0, template: "\n<div class=\"se-fe-accordion__header\" [attr.role]=\"role\" [attr.aria-level]=\"level\">\n  <se-fe-accordion-header \n    (click)=\"onClick()\"\n    (keydown)=\"onKeydown($event)\"\n    [seFeDataTitle]=\"title\"\n    [seFeDataSubtitle]=\"subtitle\"\n    [attr.aria-controls]=\"ariaControls\"\n    [attr.id]=\"this.id\"\n    [attr.aria-expanded]=\"this.expanded\"\n    tabindex=\"0\"\n    role=\"button\">\n  </se-fe-accordion-header>\n  <ng-content #actionsContent select=\"[se-fe-accordion-header-actions], [seFeAccordionHeaderActions]\"></ng-content>\n</div>\n<div \n  *ngIf=\"this.expanded\"\n  class=\"se-fe-accordion__content\"\n  role=\"region\"\n  [attr.aria-labelledby]=\"this.id\">\n  <ng-content select=\"[se-fe-accordion-content], [seFeAccordionContent]\"></ng-content>\n</div>\n", styles: [":host{display:flex;flex-direction:column;border-bottom:1px solid #d0d7db}.se-fe-accordion__header{display:flex;margin:4px 0}.se-fe-accordion__header [se-fe-accordion-header-actions]{margin-left:auto;align-self:center}.se-fe-accordion__header [se-fe-accordion-header-actions].se-fe-accordion__actions--padding{padding-left:12px}.se-fe-accordion__content{margin:0 0 16px 32px}\n"], components: [{ type: SeFeAccordionHeaderComponent, selector: "se-fe-accordion-header", inputs: ["title", "seFeDataTitle", "subtitle", "seFeDataSubtitle"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-accordion',
                    templateUrl: './se-fe-accordion.component.html',
                    styleUrls: ['./se-fe-accordion.component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { expanded: [{
                type: Input,
                args: ['seFeDataExpanded']
            }], seFeExpandedChange: [{
                type: Output
            }], title: [{
                type: Input
            }], seFeDataTitle: [{
                type: Input,
                args: ['seFeDataTitle']
            }], subtitle: [{
                type: Input
            }], seFeDataSubtitle: [{
                type: Input,
                args: ['seFeDataSubtitle']
            }], seFeDataHeadingLevel: [{
                type: Input,
                args: ['seFeDataHeadingLevel']
            }], actionsContent: [{
                type: ViewChild,
                args: ['actionsContent', { read: ElementRef, static: false }]
            }] } });

class SeFeAccordionGroupComponent {
}
SeFeAccordionGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeAccordionGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeAccordionGroupComponent, selector: "se-fe-accordion-group", ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, styles: ["se-fe-accordion-group{display:block}se-fe-accordion-group se-fe-accordion{border-bottom:1px solid #d0d7db}se-fe-accordion-group se-fe-accordion:last-child{border-bottom:none}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-accordion-group',
                    template: `<ng-content></ng-content>`,
                    encapsulation: ViewEncapsulation.None,
                    styleUrls: ['./se-fe-accordion-group.component.scss'],
                }]
        }] });

class SeFeAccordionModule {
}
SeFeAccordionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeAccordionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionModule, declarations: [SeFeAccordionComponent,
        SeFeAccordionHeaderComponent,
        SeFeAccordionGroupComponent], imports: [CommonModule,
        SeFeHeaderModule], exports: [SeFeAccordionComponent,
        SeFeAccordionHeaderComponent,
        SeFeAccordionGroupComponent] });
SeFeAccordionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionModule, imports: [[
            CommonModule,
            SeFeHeaderModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SeFeHeaderModule,
                    ],
                    declarations: [
                        SeFeAccordionComponent,
                        SeFeAccordionHeaderComponent,
                        SeFeAccordionGroupComponent,
                    ],
                    exports: [
                        SeFeAccordionComponent,
                        SeFeAccordionHeaderComponent,
                        SeFeAccordionGroupComponent,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeAccordionComponent, SeFeAccordionGroupComponent, SeFeAccordionHeaderComponent, SeFeAccordionModule };
